export const INIT_PAGE = 1
export const PER_PAGE_DEFAULT = 10
export const PER_PAGE_ALL = 10000
export const DASHBOARD_ROWS = 5
